const LIGHT = "light",
  CHECKERED = "checkered";

export { LIGHT, CHECKERED };
